export namespace ListSteps {
	export type Props = {
		items: ReadonlyArray<string>;
	};
}

export function ListSteps(props: Readonly<ListSteps.Props>) {
	return (
		<div className="flex flex-col gap-16">
			{props.items.map((item, index) => (
				<div key={index + item} className="flex gap-8 items-center">
					<div className="flex shrink-0 w-32 h-32 rounded-full  items-center justify-center text-blue-1000 bg-blue-80">
						{index + 1}
					</div>
					{item}
				</div>
			))}
		</div>
	);
}
